import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILoadingAnalysesState } from './types';

const initialState: ILoadingAnalysesState = {};

export default createSlice({
  name: 'loadingAnalyses',
  initialState,
  reducers: {
    setLoadingAnalysesInStoreAction: (
      draft,
      action: PayloadAction<{
        analysisIds: string[];
        refresh: boolean;
      }>,
    ) => {
      const { analysisIds, refresh } = action.payload;
      for (const analysisId of analysisIds) {
        draft[analysisId] = refresh;
      }
    },
    clearAllLoadingAnalysesAction: () => initialState,
    loadAnalysisAction: (draft, action: PayloadAction<string>) => {
      const analysisId = action.payload;
      delete draft[analysisId];
    },
  },
});
